import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconUserRemoveRight: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="user-remove-right, people, person, member"><path d="M1.75 20.25V19.5C1.75 15.4959 4.99594 12.25 9 12.25C13.0041 12.25 16.25 15.4959 16.25 19.5V20.25H1.75Z" stroke="currentColor" strokeWidth="1.5"/><circle cx="9" cy="7.75" r="4.5" stroke="currentColor" strokeWidth="1.5"/><path d="M17.5 9L20 11.5M20 11.5L22.5 14M20 11.5L22.5 9M20 11.5L17.5 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconUserRemoveRight;
